import type { SessionSave } from '../types';

const SESSION_KEY = 'karaokr_event_session';

export function saveSession(s: SessionSave) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(s));
}

export function loadSession(): SessionSave | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as SessionSave) : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}
